import React, { useState, useEffect, createContext, useContext } from 'react';
import ApiServices from '../../shared/ApiServices/ApiServices';
import { useUser } from '../user/UserContext';

// Create the context
const studiesConfigContext = createContext(null);
const { Provider } = studiesConfigContext;

// Custom hook to use the AppConfigContext
export const useStudiesData = () => useContext(studiesConfigContext);


// Provider component
export function StudiesProvider({ children }) {
    const [allStudies, setAllStudies] = useState(null)

    const [filterObj, setFilterObj] = useState(getDefaultFilterObj())
    const [studiesLoading, setStudiesLoading] = useState(false)

    // State for DateRange
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const { user } = useUser();

    useEffect(() => {
        if (user) {
            getAllStudies(filterObj)
        }
    }, [user]);

    const getAllStudies = async (newFilterObj: any) => {
        const {
            range,
            startDate,
            endDate,
            mrn,
            patientName,
            pagination: { next, prev }
        } = newFilterObj;

        setStudiesLoading(true);

        try {
            const res = await ApiServices.getAllStudies(
                range,
                startDate,
                endDate,
                next,
                prev,
                mrn,
                patientName
            );

            setAllStudies(res.items || []);

            setFilterObj(prev => ({
                ...prev,
                pagination: {
                    next: res.nextToken || null,
                    prev: res.previousToken || null,
                },
            }));
        } catch (error) {
            console.error('Failed to load studies:', error);
        } finally {
            setStudiesLoading(false);
        }
    };

    const studiesConfig = {
        allStudies,
        setAllStudies,
        filterObj,
        setFilterObj,
        studiesLoading,
        setStudiesLoading,
        getAllStudies,
        startDate,
        endDate,
        setStartDate,
        setEndDate
    };

    return <Provider value={studiesConfig}>{children}</Provider>;
}

export const getDefaultFilterObj = () => ({
    currentPage: 1,
    range: 10,
    startDate: null,
    endDate: null,
    mrn: '',
    patientName: '',
    pagination: {
        prev: null,
        next: null,
    }
});


export default StudiesProvider;
